import {
  applyMiddleware, compose, createStore,
} from 'redux';
import { observe } from 'redux-observers';
import thunk from 'redux-thunk';
import * as Sentry from '@sentry/react';
import rootReducer from './reducers';
import JWTMiddleware from './util/middlewares';
import observers from './observers';

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sentryReduxEnhancer = Sentry.createReduxEnhancer({});
export default function configureStore(initialState: object, httpService: any) {
  const store = createStore(rootReducer, initialState,
    composeEnhancers(applyMiddleware(JWTMiddleware(), thunk.withExtraArgument(httpService)), sentryReduxEnhancer));

  observe(store, observers);
  // @ts-ignore
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    // @ts-ignore
    module.hot.accept('./reducers', () => {
      // const nextRootReducer = require('./reducers');
      store.replaceReducer(rootReducer);
    });
  }
  return store;
}
